import React, { createContext, useState, useEffect } from 'react';
import { login } from '../services/api';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('token') || null);
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const [error, setError] = useState(null);

  // لود اطلاعات کاربر از localStorage در لود اولیه
  useEffect(() => {
    const loadUser = () => {
      const savedUser = localStorage.getItem('user');
      if (token && savedUser) {
        const parsedUser = JSON.parse(savedUser);
        setUser({ displayName: parsedUser.displayName, token });
      } else {
        setUser(null);
        setToken(null);
        localStorage.removeItem('token');
        localStorage.removeItem('user');
      }
      setInitialLoading(false);
    };
    loadUser();
  }, [token]);

  const signIn = async (userName, password, navigate) => {
    setLoading(true);
    setError(null);
    try {
      const response = await login({ userName, password });
      const { token, displayName, expiration } = response.data;
      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify({ displayName, expiration }));
      setToken(token);
      setUser({ displayName, token });
      navigate('/dashboard');
      return response;
    } catch (err) {
      let errorMessage = 'خطایی رخ داد';
      if (err.response?.status === 401) {
        errorMessage = 'نام کاربری یا رمز عبور نادرست است';
      } else if (err.response?.status === 400) {
        errorMessage = err.response.data.errors?.UserName?.[0] || 'ورودی‌ها نامعتبر هستند';
      }
      setError(errorMessage);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const signOut = () => {
    console.log('Signing out, clearing localStorage');
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, token, signIn, signOut, loading, initialLoading, error }}>
      {children}
    </AuthContext.Provider>
  );
};